import { render, staticRenderFns } from "./WarehouseOverviewPage.vue?vue&type=template&id=4f986158&scoped=true&"
import script from "./WarehouseOverviewPage.vue?vue&type=script&lang=js&"
export * from "./WarehouseOverviewPage.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseOverviewPage.vue?vue&type=style&index=0&id=4f986158&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f986158",
  null
  
)

export default component.exports